import { nodePasteRule } from '@tiptap/core';

import { AmountSelector } from '../../components/amount/amount-selector';
import { matchers } from '../config/matchers';
import { Tag } from './tag';

export const Amount = Tag.extend({
	name: 'amount',
	addOptions() {
		return {
			...this.parent?.(),
			allowMultiple: false,
			char: '+',
			component: AmountSelector,
			insertPrefixSpace: true,
			matchQuery: matchers.amount.possible,
		};
	},

	addPasteRules() {
		return [
			nodePasteRule({
				find: matchers.amount.paste,
				type: this.type,
				getAttributes: (match) => {
					return {
						id: match[0].slice(1),
					};
				},
			}),
		];
	},
});
